<script lang="ts">
    import { setContext } from "svelte";
    import type { Answer, FormInstance } from "../../global";
    import type { Form } from "../../Model/Form";
    import { answersService, formsService } from "../../services";
    import SectionAnswers from "./SectionAnswers.svelte";

    export let instance: FormInstance;

    const answersMap = new Map<string, Answer>();

    let form: Form;
    let isReady = false;

    setContext('getAnswer', (questionId: string): Answer => answersMap.get(questionId));

    $: setupComponent(instance);

    async function setupComponent(instance: FormInstance): Promise<void> {
        try {
            
            isReady = false;
            
            form = await formsService.findOne(instance.formId);
            
            const answers = await answersService.getInstanceAnswers(instance.id);

            answersMap.clear();
            for (const answer of answers) {
                answersMap.set(answer.questionId, answer);
            }

            isReady = true;

        } catch (error) {
            console.error(error);
        }
    }

</script>

{#if isReady}
    {#each form.sections as section}
        <SectionAnswers {section} />
    {/each}
{/if}
